import type { FilterConditionDTO } from "@/shared/contracts/base";
import {
  findCondition,
  removeConditions,
  upsertCondition,
} from "@/shared/contracts/query-helpers";
import { Button, Input, useDebounceCallback } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export function CollectionsFilter() {
  const nav = useNavigate({ from: "/app/catalog/collections" });
  const search = useSearch({ from: "/app/catalog/collections" }) as {
    limit?: number;
    offset?: number;
    sort?: Array<{ field: string; dir: "asc" | "desc" }> | string;
    filters?: FilterConditionDTO[] | string;
  };

  const filters = (search.filters as FilterConditionDTO[] | undefined) ?? [];
  const nameLoFilter = findCondition(filters, "nameLo");

  const [searchValue, setSearchValue] = useState<string>(
    (nameLoFilter?.value as string) || ""
  );

  useEffect(
    () => setSearchValue((nameLoFilter?.value as string) || ""),
    [nameLoFilter?.value]
  );

  const debounced = useDebounceCallback((val: string) => {
    let nextFilters = removeConditions(filters, "nameLo") ?? [];
    if (val) {
      nextFilters = upsertCondition(nextFilters, {
        field: "nameLo",
        op: "contains",
        value: val,
      });
    }
    nav({
      search: {
        ...search,
        offset: 0,
        filters: nextFilters?.length ? nextFilters : undefined,
      } as any,
    });
  }, 400);

  const hasFilter = Boolean(nameLoFilter?.value);

  return (
    <div
      className="mb-4 flex flex-wrap items-center gap-4 px-2"
      data-tourid="catalog-collections-filter"
    >
      <Input
        placeholder="ຄົ້ນຫາຊື່ Collection (ລາວ)..."
        defaultValue={searchValue}
        onChange={(e) => debounced(e.target.value)}
        className="h-8 sm:max-w-2xs"
      />
      {hasFilter && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() =>
            nav({
              search: {
                ...search,
                offset: 0,
                filters: undefined,
              } as any,
            })
          }
        >
          ລ້າງຕົວກອງ
        </Button>
      )}
    </div>
  );
}
